import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Address } from 'views/common/components';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .VMLDicon': {
    '& svg': {
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.grey[300],
      verticalAlign: 'middle',
    },
  },
  '& .VMSDnote': {
    color: theme.palette.grey[300],
    '& span:last-child': {
      fontStyle: 'italic',
    },
  },
  '& .VMSDhous': {
    color: theme.palette.grey[400],
  },
  '& .VMLDTitle': {
    fontSize: theme.spacing(2),
  },
}));

export const StyledAddress = styled(Address)(({ theme }) => ({
  '&.bookingLocation .details.operatordetails': {
    color: theme.palette.grey[300],
  },
  '& .operatorAdress': {
    fontSize: `${theme.spacing(2)} !important`,
  },
  '& .LocationLink': {
    display: 'inline-block',
  },
}));

export default StyledBox;
